module.exports = __webpack_public_path__ + "img/yt.b6042b9c.svg";